import PropTypes from 'prop-types';
import React, {Component} from 'react';

import ArticleSelection from './ArticleSelection'

import DOMPurify from 'dompurify'

import FadingImage from '../../components/FadingImage'
import TaxTag from "../../components/TaxTag";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCheck} from "@fortawesome/pro-light-svg-icons/faCheck";
import clsx from "clsx";

class ArticleInlineSelection extends Component {

    static propTypes = {
        ...ArticleSelection.articleOptions,
        itemsPerRow: PropTypes.number,
        inlineOptionStyle: PropTypes.string,
    }

    static defaultProps = {
        itemsPerRow: 2,
        canClearOnDoubleSelect: false,
        inlineOptionStyle: 'simple'
    }

    constructor(props) {
        super(props)

        this.state = {
            showMore: false
        }

    }

    renderArticleBadge = (badgeData) => {

        if (!badgeData) {
            return null
        }

        switch (badgeData.view) {

            case 'rectangle':
                return (
                    <div className="article-inline-selection__selector__badge">{badgeData.label}</div>
                )

            default:
                return null

        }

    }

    renderSelection = (handleArticleSelect, handleArticleDeSelect, articleSelectionState) => {

        const {defaultOption, selectedArticle, selectionLocked} = articleSelectionState
        const hasMoreThanMax = this.props.max && this.props.articleOptions.length > this.props.max;

        const articleOptions = this.props.articleOptions.map((articleOption, index) => {

            if (!this.state.showMore && this.props.max && index >= this.props.max && selectedArticle !== articleOption.value) {
                return null;
            }

            const price = articleOption.display.price
            const priceTag = articleOption.value === defaultOption ?
                <div key={articleOption.value + "price"} className="article-inline-selection__selector__price">{articleOption.display.inclusiveLabel ? articleOption.display.inclusiveLabel : 'inklusive'}</div> :
                <div
                    key={articleOption.value + "price"}
                    className="article-inline-selection__selector__price"
                >

                    {price.setupFee > 0 ? (
                        ["+", price.setupFee.toFixed(2), " € einmalig ", <TaxTag key="taxsetup"/>, (price.priceMonthly > 0 ? <br key={"taxbr"}/> : "")]
                    ) : ""}

                    {price.priceMonthly > 0 ? (
                        ["+", price.priceMonthly.toFixed(2), " € mtl. ", <TaxTag key="taxmonthly"/>]
                    ) : ""}

                </div>

            const isSelected = selectedArticle === articleOption.value;
            const isDisabled = articleOption.disabled;

            switch (this.props.inlineOptionStyle) {

                /*
                 extended theme contains bigger title and additional description
                 */
                case 'extended':
                    return (
                        <button
                            type="button"
                            key={articleOption.value}
                            className={clsx(
                                "article-inline-selection__selector",
                                "article-inline-selection__selector--extended",
                                isSelected && "selected",
                                isDisabled && "disabled"
                            )}
                            onClick={(e) => {
                                if (!isDisabled) {
                                    handleArticleSelect(articleOption.value)
                                }
                            }}
                        >
                            <h2>{articleOption.display.title}</h2>
                            <p dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(articleOption.display.description)}}/>
                            {(price.setupFee > 0 || price.priceMonthly > 0 || articleOption.value === defaultOption) && priceTag}
                            {this.renderArticleBadge(articleOption.display.badge)}
                            {articleOption.display.background ? <div className="article-inline-selection__selector__background"><FadingImage src={articleOption.display.background}/></div> : null}
                            {isSelected ? <div className={"article-inline-selection__selector__check"}>
                                <FontAwesomeIcon icon={faCheck}/>
                            </div> : null}
                        </button>
                    )

                /*
                 simple theme with only headline and price
                 */
                case 'simple':
                default:
                    return (
                        <a
                            key={articleOption.value}
                            className={clsx(
                                "article-inline-selection__selector--simple",
                                "article-inline-selection__selector",
                                isSelected && "selected",
                                isDisabled && "disabled"
                            )}
                            onClick={(e) => {
                                if (!isDisabled) {
                                    handleArticleSelect(articleOption.value)
                                }
                            }}
                        >
                            <div>{articleOption.display.title}</div>
                            {(price.setupFee > 0 || price.priceMonthly > 0 || articleOption.value === defaultOption) && priceTag}
                            {this.renderArticleBadge(articleOption.display.badge)}
                            {isSelected ? <div className={"article-inline-selection__selector__check"}>
                                <FontAwesomeIcon icon={faCheck}/>
                            </div> : null}
                        </a>
                    )
            }

        })

        return (
            <div className={"article-inline-selection article-inline-selection--max-" + this.props.itemsPerRow + (selectionLocked ? ' article-inline-selection--locked' : '')}>
                {articleOptions}
                {hasMoreThanMax && !this.state.showMore ?
                    <div className={"article-inline-selection__expand"}>
                        <a
                            onClick={(e) => {
                                this.setState({showMore: true})
                            }}>
                            {this.props.moreLabel}
                        </a>
                    </div>
                    : hasMoreThanMax && this.state.showMore ? <div className={"article-inline-selection__expand"}>
                        <a
                            onClick={(e) => {
                                this.setState({showMore: false})
                            }}>
                            {this.props.lessLabel}
                        </a>
                    </div> : null}
            </div>
        )

    }

    render() {
        return (
            <ArticleSelection
                {...this.props}
            >
                {(handleArticleSelect, handleArticleDeSelect, articleSelectionState) => {
                    return (
                        this.renderSelection(handleArticleSelect, handleArticleDeSelect, articleSelectionState)
                    )
                }}
            </ArticleSelection>
        )
    }

}

export default ArticleInlineSelection



/** WEBPACK FOOTER **
 ** ./src/containers/configuration/ArticleInlineSelection.js
 **/